export const cmdUrl = {
  File: {
    root: '/file',
    download: '/file/download',
    upload: '/file/upload',
  },
  Bill: {
    upload: '/bills/upload-files',
    uploadInvoice: '/bills/upload-files-invoices',
    addRefundBill: 'bills/refund-bill',
  },
  TransactionUrl: {
    root: 'v1/transactions',
    byId: `v1/transactions/{id}`,
    forBill: 'v1/transactions/bill/{number}',
    forStock: 'v1/transactions/stock-slips/{code}',
    forOrder: 'v1/transactions/order/{number}',
  },
  TransactionCategory: {
    root: '/transactionCategory',
  },
  AccountantUrl: {
    byType: 'accountants/getByType',
    getAll: 'accountants/getAll',
    imports: 'accountants/imports',
  },
  CustomerUrl: {
    root: 'v1/customers',
  },
  EmployeeUrl: {
    root: 'v1/employees',
  },
  ProviderUrl: {
    root: 'v1/providers',
  },
  InstallmentsUrl: {
    root: 'v1/installments',
    getAll: 'v1/installments/all',
  },
  DebtUrl: {
    installments: 'v1/debts/installment-bill-transactions',
    installmentWarrantyTransactions: 'v1/debts/installment-warranty-transactions',
    credits: 'v1/debts/credit-bill-transactions',
    providers: 'v1/debts/provider-transactions',
    debtInstallments: 'v1/debts/installments',
    debtProviders: 'v1/debts/providers',
    creditOrders: 'v1/debts/credit-order-transactions',
    installmentOrders: 'v1/debts/installment-order-transactions',
    shipFeeOrders: 'v1/debts/ship-fee-order-transactions',
  },
  BillUrl: {
    byCustomer: '/bills/customer/{id}',
  },
  PromotionUrl: {
    root: 'promotions',
    byId: 'promotions/{id}',
  },
  WarrantyPackageUrl: {
    root: 'warrantyPackages',
    byId: 'warrantyPackages/{id}',
  },
  AuthUrl: {
    changePwd: '/change-password',
  },
  Reports: {
    accountingByStore: '/report/accountings/stores',
    saleSummariesByStore: '/report/accountings/sale-summaries',
  },
  DiscountProgramUrl: {
    root: 'discount-programs',
    byId: 'discount-programs/{id}',
    byProduct: '/discount-programs/by-product',
  },
  OrderUrl: {
    gets: '/orders/',
  },
  TradeInUrl: {
    byCustomer: '/tradeIn/by-customer',
  },
  InstallmentProgram: {
    root: 'installment-programs',
    byId: 'installment-programs/{id}',
  },
  Campaign: {
    root: 'campaigns',
    byId: 'campaigns/{id}',
  },
  POSMForm: {
    root: 'posm-forms',
    byUuid: 'posm-forms/{uuid}',
  },
  PosmFormSubmission: {
    root: 'posm-submissions',
    byUuid: 'posm-submissions/{uuid}',
  },
  Stores: {
    root: 'stores/getStores',
  },
  ToolSync: {
    bill: 'https://app.tranngocltd.com.vn/tool-sync/bill-nhanhs/',
    billId: 'https://app.tranngocltd.com.vn/tool-sync/bill-nhanhs/{id}',
    billSearch: 'https://app.tranngocltd.com.vn/tool-sync/bill-nhanhs/search',
    product: 'https://app.tranngocltd.com.vn/tool-sync/product-nhanhs/',
    productSearch: 'https://app.tranngocltd.com.vn/tool-sync/product-nhanhs/search',
    productExcel: 'https://app.tranngocltd.com.vn/tool-sync/product-nhanhs/excel',
    cronGets: 'https://app.tranngocltd.com.vn/tool-sync/cron-jobs',
    functionGets: 'https://app.tranngocltd.com.vn/tool-sync/functions',
    cronStart: 'https://app.tranngocltd.com.vn/tool-sync/cron-jobs/start',
    cronStop: 'https://app.tranngocltd.com.vn/tool-sync/cron-jobs/stop',
    cronRemove: 'https://app.tranngocltd.com.vn/tool-sync/cron-jobs/destroy',
    order: 'https://app.tranngocltd.com.vn/tool-sync/order-nhanhs/',
    imei: 'https://app.tranngocltd.com.vn/tool-sync/product-nhanhs/',
    imeiSearch: 'https://app.tranngocltd.com.vn/tool-sync/imei-nhanhs/search',
    imeiExcel: 'https://app.tranngocltd.com.vn/tool-sync/imei-nhanhs/excel',
  },
  warrantyBenefitPolicy: {
    root: 'warranty-benefit-policy',
    byId: 'warranty-benefit-policy/{id}',
    listType: 'warranty-benefit-policy/list-type',
  },
  userToken: {
    root: 'user-token',
    byId: 'user-token/{userId}',
    revokeAllToken: 'user-token/revoke-all-token/{userId}',
    revokeToken: 'user-token/revoke-user-token/{id}',
  },
  ShippingUrl: {
    info: 'v1/orders/{id}/shipping',
    services: 'v1/orders/{id}/shipping/services',
    create: 'v1/orders/{id}/shipping',
    cancel: 'v1/orders/{id}/shipping',
    printLabel: 'v1/orders/{id}/shipping/print-label',
    carriers: 'v1/shipping-carriers',
    carrierById: 'v1/shipping-carriers/{id}',
    carrierTest: 'v1/shipping-carriers/{id}/test',
    carrierTestWithCredentials: 'v1/shipping-carriers/test',
    vtpProvinces: 'v1/shipping/vtp/provinces',
    vtpWards: 'v1/shipping/vtp/wards',
    ntProvinces: 'v1/shipping/nt/provinces',
    ntDistricts: 'v1/shipping/nt/districts',
    ntWards: 'v1/shipping/nt/wards',
    senderAddresses: 'v1/shipping/sender-addresses',
    senderAddressById: 'v1/shipping/sender-addresses/{id}',
  },
};
